jQuery(function ($) {
  const section = $('[data-postMenu]');
  const toggle  = section.find('[data-toggle]');
  const menu    = section.find('[data-menu]');

  toggle.on('click', function () {
    toggle.toggleClass('is-open');
    menu.toggleClass('is-open');
  });
});
